interface ErrorResponse {
  message?: string;
  fieldErrors?: {
    field: string;
    message: string;
  }[];
}

export default function HandleErrorResponse(
  response: ErrorResponse,
  setError: any
) {
  if (response.fieldErrors) {
    response.fieldErrors.forEach((error) => {
      const { field, message } = error;
      if (field && message) {
        setError(field, {
          message,
        });
      } else {
        console.log('Unknown error occurred.');
      }
    });
  } else {
    console.log('Unknown error response.');
  }
}
